import { Box, styled } from "@mui/material";
import SideController from "./components/SideController";
import MainPanel from "./components/MainPanel";

const CustomContainer = styled(Box)({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "28px",
  marginTop: "34px",
});

const HomeScreen = () => {
  return (
    <CustomContainer>
      <SideController />
      <MainPanel />
    </CustomContainer>
  );
};

export default HomeScreen;
